// extracted by mini-css-extract-plugin
export default {"container":"Recommendations_container__GakQE","recommendations__container":"Recommendations_recommendations__container__0lriu"};